function $offsetTop(el) {
  return el.getBoundingClientRect().top + document.documentElement.scrollTop +
    document.body.scrollTop;
}

function getGlobalOffset(el) {
  return $offsetTop(el) - window.scrollY;
}

function applyGlobalOffset({ anchor, offset }) {
  window.scroll(0, $offsetTop(anchor) - offset);
}

function getContainedOffset(el, par) {
  return el.getBoundingClientRect().top - par.getBoundingClientRect().top;
}

function applyContainedOffset({ anchor, offset }, par) {
  par.scroll(0, anchor.offsetTop - (par.offsetTop + offset));
}

export function getOffset(el, par, isSelfContained = false) {
  return (isSelfContained) ? getContainedOffset(el, par) : getGlobalOffset(el);
}

export function applyOffset(anchor, par, isSelfContained = false) {
  return (isSelfContained) ? applyContainedOffset(anchor, par) : applyGlobalOffset(anchor);
}
